import { PropsWithChildren, useMemo, useState } from 'react'
import BefehleAlleGelesenContext from '@/features/befehlsnachrichten/hooks/useBefehleAlleGelesenContext'

export default function BefehleAlleGelesenProvider({
  children
}: Readonly<PropsWithChildren>) {
  const [befehleAlleGelesen, setBefehleAlleGelesen] = useState<boolean>(false)

  const value = useMemo(
    () => ({
      befehleAlleGelesen,
      setBefehleAlleGelesen
    }),
    [befehleAlleGelesen]
  )

  return (
    <BefehleAlleGelesenContext.Provider value={value}>
      {children}
    </BefehleAlleGelesenContext.Provider>
  )
}
